/**
 * Runtime environment variables setup.
 *
 * When resolved at `runtime`, this is statically replaced by `import-meta-env` and will
 * contain the necessary environment variables according to the stage in which we are.
 *
 * Works in conjunction with the `ImportMetaEnvPlugin` declared on the Vite config file.
 *
 * @see {@link https://import-meta-env.org/guide/getting-started/runtime-transform.html}
 *
 * WARNING: This should be declared before any code import.
 */
globalThis.import_meta_env = JSON.parse('"import_meta_env_placeholder"')

/**
 * Then we import the actual `embed` script to ensure `globalThis.import_meta_env` is set first.
 *
 * WARNING: This is necessary to ensure the runtime environment variables will be available to the embed
 * script by the time it loads.
 */
import('./embed')
